fragment shiftInfo on Shift {
  id
  name
  startTime
  endTime
  monday
  tuesday
  wednesday
  thursday
  friday
  saturday
  sunday
}
